module.exports = __webpack_public_path__ + "static/media/state2.d65b53ba.svg";